import { render, staticRenderFns } from "./chat-message-voice.vue?vue&type=template&id=495c5e33&scoped=true"
import script from "./chat-message-voice.vue?vue&type=script&lang=js"
export * from "./chat-message-voice.vue?vue&type=script&lang=js"
import style0 from "./chat-message-voice.vue?vue&type=style&index=0&id=495c5e33&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495c5e33",
  null
  
)

export default component.exports